import i18n from "utils/i18n";
import {
  Validator,
  ERROR_TYPE_CD,
} from "./validator";

const ITEM_CODE = {
  EMAIL: "01",
  ACCESS_KEY: "02",
  AUTH_CODE: "03",
};
const AUTH_CODE_TEXT_LENGTH = 6;

class EmailVerificationValidator extends Validator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this.errors.email = [];
    this.errors.accessKey = [];
    this.errors.authCode = [];
  }
  /* eslint-enable */

  // アクセスキー
  checkAccessKey(key, val, attributeName, itemCd) {
    // 必須チェック
    if (val === "") {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 認証コード
  checkAuthCode(key, val, attributeName, itemCd) {
    // 必須チェック
    if (val === "") {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // 6桁の英数字のみ
    if (!Validator.isAlphaNumOnly(val) || val.length !== AUTH_CODE_TEXT_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.authCode", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }
}

class EmailVerificationSendAuthCodeValidator extends EmailVerificationValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(emailVerification) {
    const validator = new EmailVerificationSendAuthCodeValidator();

    // メールアドレス
    validator.checkEmail(
      "email",
      emailVerification.email,
      "メールアドレス",
      ITEM_CODE.EMAIL,
    );

    return validator;
  }
}

class EmailVerificationCheckAuthCodeValidator extends EmailVerificationValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(emailVerification) {
    const validator = new EmailVerificationSendAuthCodeValidator();

    // アカウント名
    validator.checkEmail(
      "email",
      emailVerification.email,
      "メールアドレス",
      ITEM_CODE.EMAIL,
    );

    // アクセスキー
    validator.checkAccessKey(
      "accessKey",
      emailVerification.accessKey,
      "アクセスキー",
      ITEM_CODE.ACCESS_KEY,
    );

    // ワンタイムパス
    validator.checkAuthCode(
      "authCode",
      emailVerification.authCode,
      "ワンタイムパス",
      ITEM_CODE.AUTH_CODE,
    );

    return validator;
  }
}

export {
  EmailVerificationSendAuthCodeValidator,
  EmailVerificationCheckAuthCodeValidator,
};
